<template>
  <div class="index">
<!--    <el-input placeholder="请输入Mac" v-model="inputMac" class="input-with-select"-->
<!--              style="height: 40px;width: 300px;float: right">-->
<!--      <el-button slot="append" icon="el-icon-search" @click="selectDeviceByMac()"></el-button>-->
<!--    </el-input>-->
    <!--    设备列表，当前产品的设备-->
    <div style="margin-top: 0px">
      <div>
        <el-table :data="deviceList" stripe height="600" style="width: 100%;line-height: 60px">
          <el-table-column prop="unionid" label="userId" min-width="25%"></el-table-column>
          <el-table-column prop="mac" label="mac" min-width="20%"></el-table-column>
          <el-table-column prop="dename" label="name" min-width="20%"
                          ></el-table-column>
          <el-table-column prop="ctime" label="bTime" min-width="25%"
                           :formatter='onlineTimeFormat'></el-table-column>
          <el-table-column prop="mainuser" label="main" min-width="10%"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'appdev',

  data() {
    return {
      deviceList: [],
      inputMac: "",

    }
  },

  methods: {
    onlineTimeFormat(row) {
      const date = new Date(row.ctime);
      const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
      console.log(formatted); // 2026-04-18 16:45:25
      return formatted
    },
  },

  mounted: function () {
    this.$axios.get("http://106.52.65.234:8099/miniBindList").then(res => {
      console.log("miniBindList res:", res);
      this.$notify(res.data)
      this.deviceList = res.data;
    }).catch(err => {
      this.$notify({title: '错误', message: err, type: 'warning'})
      return false
    })
  }
}

</script>

<style>
</style>